import { useMutation } from "@tanstack/react-query";
import { withNamespaces } from "react-i18next";
import { toast } from "react-toastify";
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Spinner
} from "reactstrap";
import DataProtectionSoftwareService from "src/modules/data-protection/apis/DataProtectionSoftwareService";

const ActivationModal = ({ t, isOpen, toggle, software, onUpdate }) => {
    const handleToggleSoftwareActivation = useMutation({
        mutationFn: async () => {
            const service = DataProtectionSoftwareService.getInstance();
            return await service.toggleActivation(software?.id);
        },
        onSuccess: () => {
            if (software?.is_inactive) {
                toast(t("Software successfully activated."), {
                    type: "success"
                });
            } else {
                toast(t("Software successfully deactivated."), {
                    type: "success"
                });
            }

            onUpdate && onUpdate();
            toggle();
        },
        onError: () => {
            if (software?.is_inactive) {
                toast(t("An error occurred while activating software."), {
                    type: "error"
                });
            }
            else {
                toast(t("An error occurred while deactivating software."), {
                    type: "error"
                });
            }
        }
    });

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
        >
            <ModalHeader
                toggle={toggle}
            >
                {t(software?.is_inactive ? 'Activate Software' : 'Deactivate Software')}
            </ModalHeader>

            <ModalBody>
                {software?.is_inactive ? (
                    <p>
                        {t('Are you sure you want to activate')} <strong>{software?.service}</strong>?
                    </p>
                ) : (
                    <p>
                        {t('Are you sure you want to deactivate')} <strong>{software?.service}</strong>?
                        <br />
                        <br/>
                        {t('Inactive software will be automatically deleted after 3 years from the deactivation date.')}
                    </p>
                )}
            </ModalBody>

            <ModalFooter>
                <Button
                    color="secondary"
                    onClick={toggle}
                >
                    {t('Cancel')}
                </Button>
                <Button
                    color={software?.is_inactive ? 'success' : 'danger'}
                    onClick={handleToggleSoftwareActivation.mutate}
                    disabled={handleToggleSoftwareActivation.isLoading}
                >
                    {handleToggleSoftwareActivation.isLoading && (
                        <Spinner size="sm" className="me-2" /> 
                    )}

                    {t(software?.is_inactive ? 'Activate' : 'Deactivate')}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(
    ActivationModal
);
